import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { signOut } from "../../redux/actions/authActions";
import { clearAppSession, getMainSignInUrl } from "../../common/sessionClear";
import { markAuthRevoked } from "../../common/authSession";

/**
 * Clears main-app session (localStorage + redirect hint). Used when signing out from
 * the educator dashboard so both origins end up logged out.
 */
const SignOut = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    markAuthRevoked();
    clearAppSession();
    dispatch(signOut());
    window.location.replace(getMainSignInUrl({ afterSignOut: true }));
  }, [dispatch]);

  return (
    <section className="SignIn">
      <p>Signing out…</p>
    </section>
  );
};

export default SignOut;
